import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { APP_TITLE, BLOB_BOIMAGE_CONTAINER } from "../../../config/constant";
import CardComponentContainer from "../../common/cardContainers/CardComponentContainer";
import mobile from "../../../assets/images/mobile.svg";
import mobileInner from "../../../assets/images/mobileInner.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/images/calender.svg";
import * as Library from "../../../utils/Library";
import ContainerLoader from "../../common/loaders/ContainerLoader";
import BtnLargeSolid from "../../common/buttons/BtnLargeSolid";
import { formatDefaultDateTimeISO } from "../../../utils/Formatter";
import ImageTags from "../../common/forms/ImageTags";
import AppContext from "../../../AppContext";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import moment from "moment/moment";
import ImageUploading from "../../common/forms/ImageUploading";
import LayoutContext from "../../../LayoutContext";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import { useDispatch, useSelector } from "react-redux";
import FormField from "../../common/forms/FormField";
import FormCard from "../../common/forms/FormCard";
import AppletPicker from "./createComponents/AppletPicker";
import { userIsOnBoardingInPage } from "../../../utils/onboardingHelper";
import BOImageMobilePreview from "./createComponents/BOImageMobilePreview";
import { setNavigations } from "../../../utils/redux/navigationAccessSlice";

/* #region  SCOPED CSS */
const StyledPage = styled.div`
    .BOtagRightElementsContainer {
        width: 100%;
        height: 100%;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        display: inline-flex;
        text-transform: none;
    }

    .Frame186 {
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .Rectangle7 {
        width: 6px;
        height: 6px;
        border-radius: 600px;
    }

    .BotagWithoutProduct {
        color: #7c868b;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .Frame1882 {
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .BotagSelected {
        color: #7c868b;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .Frame187 {
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .BotagWithProduct {
        color: #7c868b;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    // BOImageCreatorCanvas
    .Frame289 {
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 32px;
        display: inline-flex;
    }

    .BoimageCanvas {
        flex: 1 1 0;
        height: 675px;
        //padding-top: 32px;
        //padding-bottom: 32px;
        background: #10141b;
        border-radius: 8px;
        border: 2px #262e3e dotted;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 9px;
        display: inline-flex;
        overflow: hidden;
    }

    .MobilePreview {
        width: 343px;
        height: 675px;
        position: relative;
    }

    .Rectangle1 {
        width: 343px;
        height: 675px;
        left: 0px;
        top: 0px;
        position: absolute;
        background-image: url(${mobile});
    }

    .Frame313260 {
        width: 320px;
        height: 649.15px;
        left: 12px;
        top: 14.36px;
        position: absolute;
        background-image: url(${mobileInner});
    }

    .Rectangle2 {
        width: 320px;
        height: 649.15px;
        left: 0px;
        top: 0px;
        position: absolute;
    }

    .NavbarLogo {
        width: 180px;
        height: 68px;
        left: 82px;
        top: 32px;
        position: absolute;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        display: inline-flex;
    }

    .NavbarLogoImg {
        align-self: stretch;
        flex: 1 1 0;
        object-fit: cover;
    }

    .Image5 {
        width: 320px;
        height: 506px;
        left: 12px;
        top: 115px;
        position: absolute;
        object-fit: cover;
    }

    .Frame198 {
        width: 100%;
        height: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 9px;
        display: inline-flex;
        position: absolute;
        z-index: 99;
        cursor: pointer;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.8) 100%);
    }

    .Frame288 {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        display: flex;
    }

    .Pointing {
        width: 32px;
        height: 34.03px;
        position: relative;
        box-shadow: 0px 1px 0.800000011920929px rgba(0, 0, 0, 0.5);
    }

    .Frame199 {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .ClickOverEachItemsYouWantToBotag {
        text-align: center;
        color: #d1d1d1;
        font-size: 18px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .ThenLinkEachBotagToAnItemOnTheList {
        text-align: center;
        color: #d1d1d1;
        font-size: 18px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .Text700 {
        color: #d1d1d1;
        font-size: 18px;
        font-family: Roboto;
        font-weight: 700;
        word-wrap: break-word;
    }

    .Text400 {
        color: #d1d1d1;
        font-size: 18px;
        font-family: Roboto;
        font-weight: 400;
        word-wrap: break-word;
    }

    .selects.mandatory {
        border: 1px solid transparent;
        border-left: 5px solid var(--text-icons-orange-500);
        border-radius: 4px;
        outline: none;
    }

    .selects.mandatory > div {
        border: none;
        cursor: pointer;
    }

    .selects.mandatory.error {
        border: 1px solid var(--text-icons-red-500);
        border-left: 5px solid var(--text-icons-red-500);
    }

    .selects.disabled {
        border: 1px solid transparent;
        border-left: 5px solid var(--text-icons-grey-500);
        border-radius: 4px;
        outline: none;
        cursor: not-allowed;
    }

    .selects.disabled > div {
        border: none;
        cursor: not-allowed;
        color: var(--text-icons-grey-500) !important;
    }

    .text-field-custom-size {
        position: relative;
    }

    .text-field-custom-size > div {
        position: absolute;
        width: calc(300% + 32px);
    }
`;

const ContentHeaderStyled = styled.div`
    &.main-window-header-for-creator,
    &.main-window-header-for-creator * {
        box-sizing: border-box;
    }
    &.main-window-header-for-creator {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .main-window-header-for-editor {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        padding: 15px 24px 15px 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        width: 100%;
        height: 68px;
        position: relative;
    }
    .frame-40 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .inverted-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        flex-shrink: 1;
    }
    .input-selector-inverted {
        width: 348px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .frame-50 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px 0px 0px 4px;
        padding: 6px 0px 6px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 5px;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 38px;
        position: relative;
    }
    .frame-48 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .select-brand {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .inverted-field2 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 385px;
        position: relative;
    }
    .frame-313292 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        width: 647px;
        height: 38px;
        position: relative;
    }
    .btn-large-solid {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 120px;
        height: 35px;
        position: relative;
    }
    .button {
        color: var(--buttons-all-platforms-gray-200, #4f5b6d);
        text-align: left;
        font-family: var(--button-text-small-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 10px);
        letter-spacing: var(--button-text-small-letter-spacing, 0.0125em);
        font-weight: var(--button-text-small-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
`;
/* #endregion */

export default function BOImageCreatorPage() {
    const location = useLocation();
    const isCreatePage = location.pathname.includes("/create" || "/new" || "/add");
    document.title = `${APP_TITLE} - ${isCreatePage ? "New" : "Edit"} BOImage`;

    const showDevTools = process.env.REACT_APP_SHOW_DEV_TOOLS === "true";

    /* #region VARS */
    const myRef = useRef(null);
    const dispatch = useDispatch();

    //Obtain the GET parameter "continue"
    const continueParam = new URLSearchParams(location.search).get("continue");

    const navigations = useSelector(state => state.navigationAccesses);
    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigate = useNavigate();
    const { BOimageID } = useParams();

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData,
        navigations: navigations
    };

    const {
        hasUnsavedChanges,
        setHasUnsavedChanges,
        sidePanelBOtagProductLink,
        setSidePanelBOtagProductLink,
        BOTagsList,
        setBOTagsList,
        setSidePanelVisible,
        setSidePanelSection,
        sidePanelProducts,
        setSidePanelProducts,
        setSidePanelHasNewLinkedProducts,
        setSidePanelRetailBrandID,
        setSidePanelProductSearchName,
        setSidePanelSelectedProductID,
        setSidePanelSelectedProductNumber,
        brandNotSelectedShowError,
        setBrandNotSelectedShowError,
        setSidePanelHasNoProducts,
        showAddProductsPopup,
        setShowAddProductsPopup,
        boImageProductsImporting,
        setBOImageProductsImporting
    } = React.useContext(AppContext);
    const {
        setShowIsBrandSavedPopup,
        showIsBrandSavedPopup,
        productsImportedPopup,
        setProductsImportedPopup,
        setShowFirstBOImagePopup
    } = useContext(LayoutContext);

    const [isLoadingPage, setIsLoadingPage] = useState(false);
    const [loadingBrandData, setLoadingBrandData] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false);
    const [continueButtonEnabled, setContinueButtonEnabled] = useState(false);

    const [brandOptions, setBrandOptions] = useState([]);
    const [showImageInfo, setShowImageInfo] = useState(false);
    const [formFieldImageURL, setFormFieldImageURL] = useState();
    const [formFieldRetailBrandID, setFormFieldRetailBrandID] = useState("");
    const [reloadScale, setReloadScale] = useState(false);
    const [showResetBOImageContextPopup, setShowResetBOImageContextPopup] = useState(false);

    const [allFormData, setAllFormData] = useState({
        formFieldName: "",
        formFieldCollection: "",
        formFieldActivePeriodStart: "",
        formFieldActivePeriodEnd: "",
        formFieldCaption: "",
        formFieldText: "",
        formFieldGenderTarget: [],
        formFieldAgeGroups: [],
        formFieldHashtags: []
    });

    /* #endregion */

    /* #region METHODS */
    const handleContinueClicked = () => {
        myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const calculateDateEndMin = () => {
        if (allFormData?.formFieldActivePeriodStart === "") return moment().format("YYYY-MM-DD");
        return allFormData?.formFieldActivePeriodStart;
    };

    const checkFormIsValid = (highlightValidation = false) => {
        let allFieldsAreValid = true;
        if (!formFieldRetailBrandID) allFieldsAreValid = false;
        if (!formFieldImageURL) allFieldsAreValid = false;

        if (!formBOImageIDRef.current || !formConstraintsRef.current || !formTags.current) {
            console.error(
                "Form refs not found",
                formBOImageIDRef.current,
                formConstraintsRef.current,
                formTags.current
            );
            return false;
        }

        const allBotagsCompleted = allBOtagsCompleted();
        setContinueButtonEnabled(allBotagsCompleted);
        const boImageIDFieldsValid = formBOImageIDRef.current.allFieldsAreValid(highlightValidation);
        const constraintsFieldsValid = formConstraintsRef.current.allFieldsAreValid(highlightValidation);
        const tagsFieldsValid = formTags.current.allFieldsAreValid(highlightValidation);

        allFieldsAreValid =
            allFieldsAreValid &&
            allBotagsCompleted &&
            boImageIDFieldsValid &&
            constraintsFieldsValid &&
            tagsFieldsValid;

        if (
            allFormData?.formFieldActivePeriodStart &&
            allFormData?.formFieldActivePeriodEnd &&
            moment(allFormData?.formFieldActivePeriodStart).isAfter(moment(allFormData?.formFieldActivePeriodEnd))
        ) {
            if (highlightValidation)
                Library.showToastMessage({
                    type: "error",
                    message: "Active period start date cannot be after the end date"
                });
            allFieldsAreValid = false;
        }

        setSaveButtonEnabled(allFieldsAreValid);
        return allFieldsAreValid;
    };

    const allBOtagsCompleted = () => {
        if (!formFieldRetailBrandID) return false;
        if (!formFieldImageURL) return false;
        if (!BOTagsList || BOTagsList.length === 0) return false;

        return BOTagsList.reduce((acc, tag) => {
            if (!tag.completed) return false;
            return acc;
        }, true);
    };

    const handleOnImageUpload = data => {
        setShowImageInfo(true);
        setFormFieldImageURL(data);
    };

    const handleSaveClicked = () => {
        if (!checkFormIsValid(true)) {
            Library.showToastMessage({ type: "error", message: "Please fill in all the required fields" });
            return;
        }

        if (!allBOtagsCompleted()) {
            Library.showToastMessage({ type: "warning", message: "Please link all the BOtags to a product!" });
            return;
        }

        const companyIDFormValues = formBOImageIDRef.current.getAllFieldValues();
        const constraintsFormValues = formConstraintsRef.current.getAllFieldValues();
        const tagsFormValues = formTags.current.getAllFieldValues();

        const formData = {
            companyObjID: localStorage.getItem("currentCompanyID"),
            retailBrandID: formFieldRetailBrandID,
            name: companyIDFormValues?.formFieldName,
            imageURL: formFieldImageURL,
            caption: companyIDFormValues?.formFieldCaption,
            description: companyIDFormValues?.formFieldText,
            collectionName: companyIDFormValues?.formFieldCollection,
            activePeriodStartISO: formatDefaultDateTimeISO(companyIDFormValues?.formFieldActivePeriodStart, ""),
            activePeriodEndISO: formatDefaultDateTimeISO(companyIDFormValues?.formFieldActivePeriodEnd, ""),
            createdByObjID: localStorage.getItem("token"),

            targets: {
                genders: tagsFormValues?.genders.map(tag => tag.tagName),
                ageGroups: tagsFormValues?.ageGroups.map(tag => tag.tagName),
                hashTags: tagsFormValues?.hashtags.map(tag => tag.tagName)
            },

            constraints: {
                groups: constraintsFormValues?.groups,
                stores: constraintsFormValues?.stores,
                cities: constraintsFormValues?.cities,
                region: constraintsFormValues?.region,
                stock: constraintsFormValues?.stock
            },

            BOtags: BOTagsList.map(tag => {
                return {
                    beaconXposition: tag?.data?.beaconXposition,
                    beaconYposition: tag?.data?.beaconYposition,
                    GTINbarcode: tag?.data?.GTINbarcode,
                    productObjID: tag?.data?.productObjID,
                    color: tag?.data?.color,
                    size: tag?.data?.size
                };
            })
        };

        let apiMethod = "createBOimage";
        if (!isCreatePage) {
            formData._id = BOimageID;
            formData.BOimageID = BOimageID;
            apiMethod = "updateBOimage";
        }

        setHasUnsavedChanges(false);
        //console.log(`formData for ${apiMethod}:`, formData);

        Library.makeCommonPostRequest("BOimages", apiMethod, formData, false, setIsLoadingPage).then(res => {
            if (res.data.status === 200) {
                if (isCreatePage) {
                    if (userIsOnBoardingInPage(navigations, "boimages")) {
                        enableAllNavigations();
                        setShowFirstBOImagePopup(true);
                    } else {
                        const message = "BOImage created successfully";
                        Library.showToastMessage({ type: "success", message: message });
                    }

                    navigate("/boimages");
                } else Library.showUpdateMessageAndGoBack(navigate);
            } else setHasUnsavedChanges(true);
        });
    };

    const getBrandLogoURL = brandID => {
        const retailBrands = JSON.parse(localStorage.getItem("retailBrands")) ?? [];
        const brand = retailBrands.find(brand => brand._id === brandID);
        if (!brand) return "";

        return brand?.logos?.mainLogoURL;
    };

    const saveAllFieldsToLocalStorage = () => {
        const allFieldsData = {
            formBOImageIDData: formBOImageIDRef?.current?.getAllFieldValues(),
            formConstraintsData: formConstraintsRef?.current?.getAllFieldValues(),
            formTagsData: formTags?.current?.getAllFieldValues(),
            formFieldImageURL: formFieldImageURL,
            formFieldRetailBrandID: formFieldRetailBrandID,

            sidePanelProducts: sidePanelProducts,
            BOTagsList: BOTagsList
        };

        console.log("allFieldsData", allFieldsData);
        localStorage.setItem("BOImageCreatorData", JSON.stringify(allFieldsData));
    };

    const loadAllFieldsFromLocalStorage = () => {
        const allFieldsData = localStorage.getItem("BOImageCreatorData");
        if (!allFieldsData) return;

        const allFieldsObj = JSON.parse(allFieldsData);
        if (!allFieldsObj) return;

        const formBOImageIDData = allFieldsObj?.formBOImageIDData;
        //const formConstraintsData = allFieldsObj?.formConstraintsData;
        const formTagsData = allFieldsObj?.formTagsData;
        const formFieldImageURL = allFieldsObj?.formFieldImageURL;
        const formFieldRetailBrandID = allFieldsObj?.formFieldRetailBrandID;

        const sidePanelProducts = allFieldsObj?.sidePanelProducts;
        const BOTagsList = allFieldsObj?.BOTagsList;

        setFormFieldImageURL(formFieldImageURL);
        setFormFieldRetailBrandID(formFieldRetailBrandID);
        setSidePanelProducts(sidePanelProducts);

        setAllFormData({
            formFieldName: formBOImageIDData?.formFieldName,
            formFieldCollection: formBOImageIDData?.formFieldCollection,
            formFieldActivePeriodStart: formBOImageIDData?.formFieldActivePeriodStart,
            formFieldActivePeriodEnd: formBOImageIDData?.formFieldActivePeriodEnd,
            formFieldCaption: formBOImageIDData?.formFieldCaption,
            formFieldText: formBOImageIDData?.formFieldText,
            formFieldGenderTarget: formTagsData?.genders?.map(item => item?.tagName),
            formFieldAgeGroups: formTagsData?.ageGroups?.map(item => item?.tagName),
            formFieldHashtags: formTagsData?.hashtags?.map(item => item?.tagName)
        });
        setTimeout(() => {
            setBOTagsList(BOTagsList);
            setReloadScale(true);
        }, 1000);
    };

    const getProductImportedPopupMessage = () => {
        let message = "";
        let firstLine = true;

        if (productsImportedPopup?.productsImported > 0) {
            message += `${productsImportedPopup?.productsImported} products were successfully imported.`;
            firstLine = false;
        }

        if (productsImportedPopup?.productsUpdated > 0) {
            if (!firstLine) message += "<br/>";
            message += `${productsImportedPopup?.productsUpdated} products were successfully updated.`;
            firstLine = false;
        }

        if (productsImportedPopup?.productsNotImported > 0) {
            if (!firstLine) message += "<br/>";
            message += `${productsImportedPopup?.productsNotImported} products were not imported.`;
            firstLine = false;
        }

        if (productsImportedPopup?.productsImported > 0) {
            if (!firstLine) message += "<br/>";
            message += "You can now continue creating the BOImage.";
            firstLine = false;
        }

        return message;
    };

    const reloadScalingAttempts = () => {
        const reloadAttempts = [10, 200, 500, 1000];

        reloadAttempts.forEach(delay => {
            setTimeout(() => {
                setReloadScale(true);
            }, delay);
        });
    };

    const enableAllNavigations = () => {
        setShowFirstBOImagePopup(true);

        const allNavigationsNames = [
            "organization",
            "companies",
            "retailBrands",
            "BOimages",
            "products",
            "stores",
            "fulfillmentCenters",
            "dashboard",
            "orders",
            "promoters"
        ];

        const disabledNavigations = ["orders", "promoters"];
        const navigationsUpdated = {};

        allNavigationsNames.forEach(nav => {
            const navigationPanelEnabled = !disabledNavigations.includes(nav);
            navigationsUpdated[nav] = { navigationPanel: navigationPanelEnabled, createModeOnly: false };
        });
        dispatch(setNavigations({ navigationAccesses: navigationsUpdated }));
    };

    const resetBOImageContext = (resetBrand = false) => {
        setSidePanelProducts([]);
        setBOTagsList([]);
        setSidePanelVisible(false);
        setSidePanelSection("Products");
        setSidePanelBOtagProductLink(null);
        setSidePanelHasNewLinkedProducts(false);
        setSidePanelProductSearchName("");
        if (resetBrand) setSidePanelRetailBrandID(null);
        setSidePanelSelectedProductID(undefined);
        setSidePanelSelectedProductNumber(undefined);
        setBrandNotSelectedShowError(false);
        setSidePanelHasNoProducts(false);
    };

    const refreshTargetAndHashtags = async retailBrandID => {
        if (!retailBrandID) return;

        const res = await Library.makePostRequest(
            "getRetailBrand",
            { retailBrandID: retailBrandID },
            false,
            setLoadingBrandData
        );
        if (res.data.status === 200) {
            const data = res.data.data;
            if (!data) return;

            if (!continueParam) {
                const targets = data?.targets;
                const genders = targets?.genders;
                const ageGroups = targets?.ageGroups;
                const hashTags = targets?.hashTags;

                setAllFormData({
                    ...allFormData,
                    formFieldGenderTarget: genders,
                    formFieldAgeGroups: ageGroups,
                    formFieldHashtags: hashTags
                });
            }
        }
    };

    const checkNameAvailability = async name => {
        if (!name) return;

        const res = await Library.makeCommonPostRequest(
            "BOImages",
            "checkBOImageNameAvailability",
            { name: name, companyObjID: localStorage.getItem("currentCompanyID") },
            false
        );
        if (res.data.status === 200) {
            const data = res?.data?.data;
            if (!data) return;

            const nameAvailable = data?.nameAvailable;
            if (!nameAvailable) {
                formFields1Refs.formFieldName.setOutsideInvalid(
                    true,
                    "BOImage name already exists, please choose another"
                );
            }
        }
    };

    const handleOnImageRemove = () => {
        resetBOImageContext();
        setShowImageInfo(false);
        setFormFieldImageURL(null);
        setShowResetBOImageContextPopup(false);
    };
    /* #endregion */

    /* #region FORM FIELDS */
    //BOIMAGE ID FORM STANDARD:
    const formBOImageIDRef = useRef();
    const formFields1Refs = [];
    const FormCardFields1 = [
        <FormField
            type="text"
            title="Name (Internal)"
            tooltip="Name of the BOImage"
            requiredType="mandatory"
            value={allFormData?.formFieldName}
            onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldName: text });
            }}
            onTextBlur={text => checkNameAvailability(text)}
            varName="formFieldName"
            ref={el => (formFields1Refs.formFieldName = el)}
        />,
        <FormField
            type="text"
            title="To collection"
            tooltip="Collection name"
            //value={allFormData?.formFieldCollection}
            /*onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldCollection: text });
            }}*/
            varName="formFieldCollection"
            placeholder="Not available"
            requiredType="locked"
            ref={el => (formFields1Refs.formFieldCollection = el)}
        />,
        <FormField
            type="date"
            title="Active Period Start"
            tooltip="Start date of the active period"
            value={allFormData?.formFieldActivePeriodStart}
            datePickerPlaceholder="Always Active"
            minDate={moment().format("YYYY-MM-DD")}
            leftContent={<CalendarIcon className="flex" />}
            onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldActivePeriodStart: text });
                if (allFormData?.formFieldActivePeriodEnd === "") return;

                if (moment(text).isAfter(moment(allFormData?.formFieldActivePeriodEnd))) {
                    Library.showErrorMessage("Active period start date cannot be after the end date");
                }
            }}
            varName="formFieldActivePeriodStart"
            ref={el => (formFields1Refs.formFieldActivePeriodStart = el)}
        />,
        <FormField
            type="date"
            title="Active Period End"
            tooltip="End date of the active period"
            value={allFormData?.formFieldActivePeriodEnd}
            datePickerPlaceholder="Always Active"
            minDate={calculateDateEndMin()}
            leftContent={<CalendarIcon className="flex" />}
            onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldActivePeriodEnd: text });
            }}
            varName="formFieldActivePeriodEnd"
            ref={el => (formFields1Refs.formFieldActivePeriodEnd = el)}
        />,
        <FormField
            type="text"
            title="Caption (meta data)"
            tooltip="Caption of the BOImage"
            requiredType="mandatory"
            value={allFormData?.formFieldCaption}
            onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldCaption: text });
            }}
            varName="formFieldCaption"
            ref={el => (formFields1Refs.formFieldCaption = el)}
        />,
        <FormField
            type="text"
            title="Text"
            tooltip="Description of the BOImage"
            value={allFormData?.formFieldText}
            onTextChange={text => {
                setAllFormData({ ...allFormData, formFieldText: text });
            }}
            varName="formFieldText"
            ref={el => (formFields1Refs.formFieldText = el)}
            formFieldColumSize="3"
            multiLine={{
                isMultiLine: true,
                autoExpand: true,
                maxLines: 6
            }}
            //resizable={true}
            //defaultSize={"calc(33.333% - 10px"}
        />
    ];

    //CONSTRAINTS FORM STANDARD:
    const formConstraintsRef = useRef();
    const formFieldsConstraintsRefs = [];
    const FormCardFieldsConstraints = [
        <FormField
            type="text"
            title="Groups"
            tooltip="Groups"
            requiredType="locked"
            value=""
            disabled={true}
            varName="groups"
            ref={el => (formFieldsConstraintsRefs.groups = el)}
        />,
        <FormField
            type="text"
            title="Stores"
            tooltip="Stores"
            requiredType="locked"
            value=""
            disabled={true}
            varName="stores"
            ref={el => (formFieldsConstraintsRefs.stores = el)}
        />,
        <FormField
            type="text"
            title="Cities"
            tooltip="Cities"
            requiredType="locked"
            value=""
            disabled={true}
            varName="cities"
            ref={el => (formFieldsConstraintsRefs.cities = el)}
        />,
        <FormField
            type="text"
            title="Region"
            tooltip="Region"
            requiredType="locked"
            value=""
            disabled={true}
            varName="region"
            ref={el => (formFieldsConstraintsRefs.region = el)}
        />,
        <FormField
            type="text"
            title="Stock"
            tooltip="Stock"
            requiredType="locked"
            value=""
            disabled={true}
            varName="stock"
            ref={el => (formFieldsConstraintsRefs.stock = el)}
        />
    ];

    //TARGETS & HASHTAGS FORMS STANDARD:
    const formTags = useRef();
    const formTagsRef = [];
    const formTagFields = [
        <FormField
            type="tags"
            title="Gender target"
            tooltip="Genders"
            requiredType="simple"
            varName="genders"
            placeholderWidth="150px"
            ref={el => (formTagsRef.genders = el)}
            value={allFormData?.formFieldGenderTarget}
            tagsChange={tags => {
                //setFormFieldGenderTarget(tags);

                setAllFormData({ ...allFormData, formFieldGenderTarget: tags });
            }}
        />,
        <FormField
            type="tags"
            title="Age groups"
            tooltip="Age groups"
            requiredType="simple"
            varName="ageGroups"
            placeholderWidth="150px"
            ref={el => (formTagsRef.ageGroups = el)}
            value={allFormData?.formFieldAgeGroups}
            tagsChange={tags => {
                setAllFormData({ ...allFormData, formFieldAgeGroups: tags });
            }}
        />,
        <FormField
            type="tags"
            title="Hashtags"
            tooltip="Hashtags"
            requiredType="simple"
            assistiveText=""
            varName="hashtags"
            placeholderWidth="150px"
            ref={el => (formTagsRef.hashtags = el)}
            value={allFormData?.formFieldHashtags}
            tagsChange={tags => {
                setAllFormData({ ...allFormData, formFieldHashtags: tags });
            }}
        />
    ];

    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        const userIsOnboarding = userIsOnBoardingInPage(navigations, "boimages");

        setupHeaders(
            props,
            isCreatePage,
            brandOptions,
            brandNotSelectedShowError,
            formFieldRetailBrandID,
            setFormFieldRetailBrandID,
            setBrandNotSelectedShowError,
            saveButtonEnabled,
            handleSaveClicked,
            continueButtonEnabled,
            handleContinueClicked,
            userIsOnboarding,
            navigations
        );
    }, [
        props?.layoutType,
        location,
        brandOptions,
        brandNotSelectedShowError,
        formFieldRetailBrandID,
        saveButtonEnabled,
        continueButtonEnabled,
        navigations
    ]);

    useEffect(() => {
        setSidePanelHasNoProducts(false);
        const retailBrands = JSON.parse(localStorage.getItem("retailBrands")) ?? [];

        const brandOptions = retailBrands.map(brand => {
            return {
                key: brand._id,
                label: brand.name
            };
        });

        setBrandOptions(brandOptions);

        //IF ONLY ONE BRAND, AUTO SELECT IT

        if (brandOptions.length === 1) {
            setFormFieldRetailBrandID(brandOptions[0].key);
        }
    }, []);

    /* useEffect(() => {
        if (sidePanelHasNoProducts) {
            setShowAddProductsPopup(true);
        }
    }, [sidePanelHasNoProducts]); */

    useEffect(() => {
        setSidePanelRetailBrandID(formFieldRetailBrandID);

        if (isCreatePage && !continueParam) refreshTargetAndHashtags(formFieldRetailBrandID);
    }, [formFieldRetailBrandID]);

    // RESETS ALL CONTEXT VARIABLES (AND FETCHES THE BOIMAGE DATA IF IN EDIT MODE) when the page is loaded
    useEffect(() => {
        //FIRST TIME IN PAGE RESET ALL CONTEXT VARIABLES
        if (continueParam !== "true") {
            resetBOImageContext();
        }

        if (location.pathname.includes("/boimages/create")) {
            if (continueParam === "true") {
                loadAllFieldsFromLocalStorage();
                //TODO: CHECK SIDEPANEL HAS NOW PRODUCTS
                reloadScalingAttempts();
            }
        } else if (location.pathname.includes("/boimages/edit")) {
            if (!BOimageID) return;

            Library.makeCommonPostRequest(
                "BOimages",
                "getBOimage",
                { BOimageID: BOimageID },
                false,
                setIsLoadingPage
            ).then(res => {
                if (res.data.status === 200) {
                    const product = res.data.data;

                    setAllFormData({
                        formFieldName: product?.name,
                        formFieldCollection: product?.collectionName,
                        formFieldActivePeriodStart: product?.activePeriodStartISO
                            ? moment(product?.activePeriodStartISO).format("YYYY-MM-DD")
                            : "",
                        formFieldActivePeriodEnd: product?.activePeriodEndISO
                            ? moment(product?.activePeriodEndISO).format("YYYY-MM-DD")
                            : "",
                        formFieldCaption: product?.caption,
                        formFieldText: product?.description,
                        formFieldGenderTarget: product?.targets?.genders,
                        formFieldAgeGroups: product?.targets?.ageGroups,
                        formFieldHashtags: product?.targets?.hashTags
                    });

                    setFormFieldImageURL(product?.imageURL);
                    setFormFieldRetailBrandID(product?.retailBrandID);

                    const BOTags = product?.BOtags?.map((tag, index) => {
                        return {
                            number: index + 1,
                            selected: false,
                            completed: true,
                            data: {
                                beaconXposition: tag?.beaconXposition,
                                beaconYposition: tag?.beaconYposition,
                                GTINbarcode: tag?.GTINbarcode,
                                productObjID: tag?.productObjID,
                                color: tag?.color,
                                size: tag?.size
                            },
                            naturalX: tag?.beaconXposition,
                            naturalY: tag?.beaconYposition,
                            GTINbarcode: tag?.GTINbarcode,
                            selectedColor: tag?.color,
                            selectedSize: tag?.size,

                            //new
                            image: tag?.image,
                            category: tag?.category,
                            productName: tag?.productName,
                            colors: tag?.colors,
                            sizes: tag?.sizes
                        };
                    });
                    setBOTagsList(BOTags);

                    reloadScalingAttempts();
                }
            });
        }

        return () => {
            //on exit reset all context variables
            resetBOImageContext();
        };
        //}, [location, BOimageID]);
    }, []);

    // LINKS A PRODUCT TO A BOTAG, when the link button is clicked
    useEffect(() => {
        if (!sidePanelBOtagProductLink) return;
        const tagNumber = sidePanelBOtagProductLink.tagNumber;
        const selectedBOtag = BOTagsList.find(tag => tag.number === tagNumber);

        if (!selectedBOtag) {
            Library.showToastMessage({ type: "warning", message: "Please select a BOtag first" });
            return;
        }
        const productObjID = sidePanelBOtagProductLink.productID;

        const BOtag = {
            beaconXposition: selectedBOtag.naturalX,
            beaconYposition: selectedBOtag.naturalY,
            productObjID: productObjID,

            color: sidePanelBOtagProductLink.selectedColor,
            size: sidePanelBOtagProductLink.selectedSize,
            image: sidePanelBOtagProductLink.image,
            category: sidePanelBOtagProductLink.category,
            productName: sidePanelBOtagProductLink.productName,
            colors: sidePanelBOtagProductLink.colors,
            sizes: sidePanelBOtagProductLink.sizes,
            GTINbarcode: sidePanelBOtagProductLink.GTINbarcode
        };

        //Set tag as completed
        setBOTagsList(tags => {
            const updatedTags = tags.map(tag => {
                if (tag.number === tagNumber) {
                    const tagTmp = tag;
                    tagTmp.selected = false;
                    tagTmp.completed = true;
                    tagTmp.data = BOtag;
                    tagTmp.image = sidePanelBOtagProductLink.image;
                    tagTmp.category = sidePanelBOtagProductLink.category;
                    tagTmp.productName = sidePanelBOtagProductLink.productName;
                    tagTmp.colors = sidePanelBOtagProductLink.colors;
                    tagTmp.colorNames = sidePanelBOtagProductLink.colorNames;
                    tagTmp.sizes = sidePanelBOtagProductLink.sizes;
                    tagTmp.GTINbarcode = sidePanelBOtagProductLink.GTINbarcode;
                    return tagTmp;
                } else {
                    const unselectedTag = tag;
                    unselectedTag.selected = false;
                    return unselectedTag;
                }
            });

            //if all botags completed hide sidepanel
            if (updatedTags.reduce((acc, tag) => (tag.completed ? acc + 1 : acc), 0) === updatedTags.length)
                setSidePanelVisible(false);

            return updatedTags;
        });

        setSidePanelHasNewLinkedProducts(true);
        setSidePanelBOtagProductLink(null);
        //setSidePanelSection("Linked Products");

        Library.showToastMessage({ type: "success", message: `You have successfully linked BOtag ${tagNumber}.` });
    }, [sidePanelBOtagProductLink]);

    useEffect(() => {
        checkFormIsValid(false);
    }, [BOTagsList]);

    useEffect(() => {
        if (boImageProductsImporting === 1) {
            if (hasUnsavedChanges) {
                setHasUnsavedChanges(false);
                return;
            }

            setTimeout(() => {
                setBOImageProductsImporting(2);
                saveAllFieldsToLocalStorage();

                navigate("/products/add");
                setSidePanelSection("Products");
            }, 10);
        }
    }, [boImageProductsImporting, hasUnsavedChanges]);
    /* #endregion */

    return (
        <ContainerLoader
            isLoading={isLoadingPage || loadingBrandData}
            addBlurFilters={false}
            loadingPositionFromTop="400px">
            <FullScreenOverlay show={showIsBrandSavedPopup}>
                <DialogBoxComponent
                    headingFontSize="16px"
                    buttonWidth="50%"
                    onClickYes={() => setShowIsBrandSavedPopup(false)}
                    title="Your Retail Brand is now saved."
                    heading="Success!"
                    headingColor="#00BB00"
                    message="<div style='font-size: 14px; margin: 0 -5px;'>You can now proceed with creating your first BOimage, any of your images powered by BOtag technology.</div>"
                    showConfirm={true}
                    showCancel={false}
                    confirmText="CONTINUE"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showResetBOImageContextPopup}>
                <DialogBoxComponent
                    headingFontSize="16px"
                    buttonWidth="50%"
                    onClickYes={() => handleOnImageRemove()}
                    onClickNo={() => setShowResetBOImageContextPopup(false)}
                    title="Warning"
                    heading="Success!"
                    headingColor="#00BB00"
                    message="<div style='font-size: 14px; margin: 0 -5px;'>Please confirm you want to remove the image from the canvas?</div>"
                    showConfirm={true}
                    showCancel={true}
                    cancelText="CANCEL"
                    confirmText="CONFIRM"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showAddProductsPopup}>
                <AppletPicker onClose={() => setShowAddProductsPopup(false)} />
            </FullScreenOverlay>

            <FullScreenOverlay show={productsImportedPopup?.show}>
                <DialogBoxComponent
                    headingFontSize="16px"
                    buttonWidth="151px"
                    buttonFontSize="12px"
                    onClickYes={() => {
                        setProductsImportedPopup({
                            show: false,
                            productsImported: 0,
                            productsUpdated: 0,
                            productsNotImported: 0
                        });

                        setSidePanelVisible(true);
                    }}
                    title={productsImportedPopup?.productsImported > 0 ? "Products imported!" : "No products imported!"}
                    heading={productsImportedPopup?.productsImported > 0 ? "COMPLETED!" : "ATTENTION!"}
                    message={`<div style='font-size: 14px; margin: 0 -5px;'>${getProductImportedPopupMessage()}</div>`}
                    showConfirm={true}
                    showCancel={false}
                    confirmText="CONTINUE"
                />
            </FullScreenOverlay>

            <StyledPage style={{ width: "100%" }}>
                {/* TODO: REMOVE LATER: BUTTONS FOR TESTING PURPOSES */}
                <div
                    className="flex flex-row justify-between gap-16px items-center mb-16px"
                    style={{ display: showDevTools ? "flex" : "none" }}>
                    <BtnLargeSolid
                        text="SAVE ALL"
                        onClick={() => {
                            saveAllFieldsToLocalStorage();
                        }}
                    />

                    <BtnLargeSolid
                        text="LOAD ALL"
                        onClick={() => {
                            loadAllFieldsFromLocalStorage();
                        }}
                    />

                    <BtnLargeSolid
                        text="RESET ALL"
                        onClick={() => {
                            setFormFieldImageURL("");
                            //setFormFieldRetailBrandID("");
                            setBOTagsList([]);
                            setAllFormData({
                                formFieldName: "",
                                formFieldCollection: "",
                                formFieldActivePeriodStart: "",
                                formFieldActivePeriodEnd: "",
                                formFieldCaption: "",
                                formFieldText: "",
                                formFieldGenderTarget: [],
                                formFieldAgeGroups: [],
                                formFieldHashtags: []
                            });
                        }}
                    />

                    <BtnLargeSolid
                        text="RELOAD SCALING"
                        onClick={() => {
                            setReloadScale(true);
                        }}
                    />

                    <BtnLargeSolid
                        text="PRINT STATS"
                        onClick={() => {
                            console.log("BOTagsList:", BOTagsList);
                        }}
                    />

                    <BtnLargeSolid
                        text="END ONBOARDING"
                        onClick={() => {
                            enableAllNavigations();
                            setShowFirstBOImagePopup(true);
                            navigate("/boimages");
                        }}
                    />

                    <BtnLargeSolid
                        text="SHOW IMPORTED"
                        onClick={() => {
                            setProductsImportedPopup({
                                show: true,
                                productsImported: 5,
                                productsUpdated: 5,
                                productsNotImported: 5
                            });
                        }}
                    />
                </div>

                <BOImageCreatorCanvas
                    formFieldImageURL={formFieldImageURL}
                    BOTagsList={BOTagsList}
                    setBOTagsList={setBOTagsList}
                    showImageInfo={showImageInfo}
                    setShowImageInfo={setShowImageInfo}
                    formFieldRetailBrandID={formFieldRetailBrandID}
                    setBrandNotSelectedShowError={setBrandNotSelectedShowError}
                    handleOnImageUpload={handleOnImageUpload}
                    brandLogoURL={getBrandLogoURL(formFieldRetailBrandID)}
                    reloadScale={reloadScale}
                    setReloadScale={setReloadScale}
                    handleOnImageRemove={() => {
                        setShowResetBOImageContextPopup(true);
                    }}
                />

                <div ref={myRef}>
                    <FormCard
                        title="BOImage ID"
                        ref={formBOImageIDRef}
                        numOfFieldsPerLine={4}
                        showDefaultRightLegends={true}
                        formFields={FormCardFields1}
                        formFieldRefs={formFields1Refs}
                        onFormChanged={() => {
                            checkFormIsValid(false);
                        }}
                        showUnsavedChangesPopup={true}
                    />

                    <FormCard
                        title="CONSTRAINTS"
                        showDefaultRightLegends={true}
                        numOfFieldsPerLine={3}
                        formFields={FormCardFieldsConstraints}
                        formFieldRefs={formFieldsConstraintsRefs}
                        ref={formConstraintsRef}
                        onFormChanged={() => {
                            checkFormIsValid(false);
                        }}
                        showUnsavedChangesPopup={true}
                    />

                    <FormCard
                        ref={formTags}
                        title="TARGETS & HASHTAGS"
                        numOfFieldsPerLine={3}
                        showDefaultRightLegends={true}
                        formFields={formTagFields}
                        formFieldRefs={formTagsRef}
                        onFormChanged={() => {
                            checkFormIsValid(false);
                        }}
                        showUnsavedChangesPopup={true}
                    />
                </div>
            </StyledPage>
        </ContainerLoader>
    );
}

/* #region SMALL COMPONENTS */
function setupHeaders(
    props,
    isCreatePage,
    brandOptions,
    brandNotSelectedShowError,
    formFieldRetailBrandID,
    setFormFieldRetailBrandID,
    setBrandNotSelectedShowError,
    saveEnabled,
    onSaveClicked,
    continueEnabled,
    continueClicked,
    userIsOnboarding,
    navigations
) {
    props.setControlBarLeftBtns([{ to: "#", disabled: true, title: "BOImages", icon: "fa-magnifying-glass" }]);
    props.setControlBarCenterBtns([{ to: "#", active: true, disabled: false, title: "BOIMAGES" }]);

    const createMode = navigations?.navigationAccesses?.BOimages?.createModeOnly;

    if (isCreatePage) {
        props.setControlBarRightBtns([
            { to: "/boimages", active: false, disabled: createMode, title: "View", icon: "eye" },
            { to: "/boimages/create", active: true, disabled: false, title: "Add", icon: "plus" },
            { to: "/boimages/empty", active: false, disabled: createMode, title: "Details", icon: "microscope" }
        ]);
    } else {
        props.setControlBarRightBtns([
            { to: "/boimages", active: false, disabled: false, title: "Back", icon: "chevron-left" },
            { to: "/boimages/edit", active: true, disabled: false, title: "Edit", icon: "pencil-line" }
        ]);
    }

    props.setFilterHeaderProperties({
        customContentHeader: (
            <ContentHeaderNewBOimageV2
                isCreatePage={isCreatePage}
                brandOptions={brandOptions}
                brandNotSelectedShowError={brandNotSelectedShowError}
                formFieldRetailBrandID={formFieldRetailBrandID}
                setFormFieldRetailBrandID={setFormFieldRetailBrandID}
                setBrandNotSelectedShowError={setBrandNotSelectedShowError}
                saveEnabled={saveEnabled}
                onSaveClicked={onSaveClicked}
                continueEnabled={continueEnabled}
                continueClicked={continueClicked}
                userIsOnboarding={userIsOnboarding}
            />
        )
    });
}

const PoitingShapeSVG = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="37" viewBox="0 0 35 37" fill="none">
            <g filter="url(#filter0_d_3086_15710)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.95432 26.9223C7.33193 26.1221 6.55394 24.4994 5.19802 22.4767C4.42003 21.3653 2.50841 19.2536 1.93047 18.1644C1.51385 17.5025 1.39296 16.6966 1.59705 15.9416C1.94595 14.5061 3.30765 13.5539 4.77568 13.7188C5.9111 13.9468 6.95454 14.5033 7.77649 15.3192C8.35038 15.8597 8.87827 16.4471 9.35469 17.0752C9.71035 17.5198 9.79926 17.6976 10.1994 18.2088C10.5995 18.7201 10.8662 19.2313 10.6662 18.4756C10.5106 17.3642 10.2438 15.497 9.86594 13.8299C9.57698 12.5629 9.51029 12.3628 9.24355 11.407C8.97681 10.4512 8.82122 9.65099 8.53225 8.56181C8.26811 7.49168 8.06036 6.40842 7.90986 5.31649C7.62968 3.9199 7.83352 2.46953 8.48779 1.20427C9.26443 0.473788 10.4037 0.280988 11.3775 0.715254C12.3568 1.43842 13.087 2.44828 13.4669 3.60492C14.0494 5.02839 14.4382 6.52363 14.6228 8.05056C14.9784 10.2734 15.6675 13.5187 15.6897 14.1855C15.6897 13.3631 15.5341 11.6293 15.6897 10.8513C15.8439 10.0403 16.4076 9.36716 17.179 9.07306C17.841 8.86995 18.5413 8.82428 19.224 8.93969C19.9132 9.08376 20.5236 9.48016 20.9356 10.0511C21.4506 11.3479 21.7364 12.7243 21.7803 14.1189C21.8398 12.8976 22.0488 11.6883 22.4027 10.5179C22.7741 9.99453 23.3165 9.61718 23.9364 9.45094C24.6712 9.31658 25.4244 9.31658 26.1592 9.45094C26.7618 9.65239 27.2889 10.0322 27.6707 10.5401C28.1415 11.719 28.4264 12.9638 28.5154 14.23C28.5154 14.5412 28.671 13.3631 29.16 12.5851C29.4141 11.8307 30.0515 11.2691 30.8319 11.112C31.6123 10.9549 32.4173 11.226 32.9435 11.8233C33.4698 12.4206 33.6375 13.2533 33.3834 14.0077C33.3834 15.4526 33.3834 15.3859 33.3834 16.3639C33.3834 17.3419 33.3834 18.2088 33.3834 19.0313C33.3024 20.332 33.1241 21.6249 32.8499 22.899C32.4631 24.0262 31.9247 25.0956 31.2495 26.0776C30.1702 27.2779 29.2784 28.6343 28.6043 30.1009C28.4371 30.8296 28.3624 31.5764 28.382 32.3238C28.3798 33.0142 28.4695 33.7019 28.6488 34.3688C27.7399 34.4648 26.8235 34.4648 25.9147 34.3688C25.0478 34.2354 23.9809 32.5016 23.6919 31.9681C23.5489 31.6817 23.2563 31.5007 22.9361 31.5007C22.616 31.5007 22.3233 31.6817 22.1804 31.9681C21.6913 32.8128 20.6022 34.3465 19.8464 34.4354C18.3571 34.6133 15.2896 34.4354 12.8668 34.4354C12.8668 34.4354 13.2669 32.2126 12.3555 31.4124C11.4441 30.6122 10.5106 29.6786 9.82149 29.0562L7.95432 26.9223Z"
                    stroke="#D1D1D1"
                    strokeWidth="0.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.8038 28.1356V20.4629C26.8038 20.0037 26.4306 19.6313 25.9703 19.6313C25.5099 19.6313 25.1367 20.0037 25.1367 20.4629V28.1356C25.1367 28.5949 25.5099 28.9672 25.9703 28.9672C26.4306 28.9672 26.8038 28.5949 26.8038 28.1356Z"
                    fill="#D1D1D1"
                />
                <path
                    d="M22.4025 28.1328L22.358 20.4562C22.3554 19.998 21.98 19.6287 21.5197 19.6314C21.0593 19.634 20.6883 20.0076 20.6909 20.4657L20.7354 28.1424C20.738 28.6005 21.1134 28.9698 21.5737 28.9672C22.0341 28.9645 22.4051 28.591 22.4025 28.1328Z"
                    fill="#D1D1D1"
                />
                <path
                    d="M16.2456 20.4738L16.2901 28.1345C16.2928 28.5971 16.6681 28.9699 17.1285 28.9672C17.5888 28.9645 17.9598 28.5873 17.9572 28.1248L17.9127 20.464C17.91 20.0015 17.5347 19.6287 17.0743 19.6314C16.6139 19.6341 16.2429 20.0112 16.2456 20.4738Z"
                    fill="#D1D1D1"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_3086_15710"
                    x="0.325"
                    y="0.11084"
                    width="34.35"
                    height="36.5788"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="0.4" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3086_15710" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3086_15710" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};

const ContentHeaderNewBOimageV2 = ({
    isCreatePage,
    brandOptions,
    brandNotSelectedShowError,
    formFieldRetailBrandID,
    setFormFieldRetailBrandID,
    setBrandNotSelectedShowError,
    saveEnabled,
    onSaveClicked,
    continueClicked,
    continueEnabled,
    userIsOnboarding
}) => {
    const isDisabled = !brandOptions || userIsOnboarding || brandOptions?.length === 1;
    const defaultRetailBrandID = localStorage.getItem("defaultRetailBrand");

    const mappedBrandOptions = brandOptions.map(option => {
        let retailBrandName = option.label;

        if (option?.key === defaultRetailBrandID) {
            retailBrandName = `${option?.label} (default)`;
        }
        return {
            value: option.key,
            name: retailBrandName,
            selected: option.key === formFieldRetailBrandID
        };
    });

    useEffect(() => {
        if (!mappedBrandOptions) return;
        const currentRetailBrand = sessionStorage.getItem("currentRetailBrand") || "";
        const currentRetailBrandObject = mappedBrandOptions?.find(item => item.value === currentRetailBrand);
        const defaultRetailBrand = localStorage.getItem("defaultRetailBrand") || "";
        const defaultRetailBrandObject = mappedBrandOptions?.find(item => item.value === defaultRetailBrand);
        const value = currentRetailBrandObject || defaultRetailBrandObject || mappedBrandOptions?.[0];

        setFormFieldRetailBrandID(value?.value || "");
        setBrandNotSelectedShowError(false);
    }, [mappedBrandOptions]);

    return (
        <ContentHeaderStyled className="main-window-header-for-creator">
            <div className="main-window-header-for-editor">
                <div className="frame-40">
                    <div className="inverted-field">
                        <FormField
                            className="input-selector-inverted"
                            type="dropdown"
                            dropdownData={mappedBrandOptions?.sort((a, b) => a?.name?.localeCompare(b?.name))}
                            varName="brandSelected"
                            requiredType={isDisabled ? "mandatoryLocked" : "mandatory"}
                            isDropdownMultiselect={false}
                            isDropdownSearchable={false}
                            styling={{ backgroundColor: "var(--Buttons-All-Platforms-Gray-300)" }}
                            onDropdownChange={data => {
                                //TODO: TEST THIS DROPDOWN CHANGE IF IS WORKING PROPERLY
                                setFormFieldRetailBrandID(data.value);
                                setBrandNotSelectedShowError(false);
                                sessionStorage.setItem("currentRetailBrand", data?.value || "");
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <BtnLargeSolid
                            onClick={continueClicked}
                            className="mr-8px"
                            disabled={!continueEnabled}
                            text={"CONTINUE"}
                        />
                        <BtnLargeSolid
                            type="submit"
                            onClick={onSaveClicked}
                            disabled={!saveEnabled}
                            text={isCreatePage ? "CREATE" : "UPDATE"}
                        />
                    </div>
                </div>
            </div>
        </ContentHeaderStyled>
    );
};

const BOImageCreatorCanvas = ({
    formFieldImageURL,
    BOTagsList,
    setBOTagsList,
    showImageInfo,
    setShowImageInfo,
    formFieldRetailBrandID,
    setBrandNotSelectedShowError,
    handleOnImageUpload,
    brandLogoURL,
    reloadScale,
    setReloadScale,
    handleOnImageRemove
}) => {
    return (
        <CardComponentContainer title="BOImage Creator Canvas" spacing="16px" rightComponent={<BOtagRightElements />}>
            <div>
                <div className="Frame289">
                    <div className="BoimageCanvas" style={{ position: "relative", zIndex: "999" }}>
                        {showImageInfo && (
                            <div
                                className="Frame198"
                                onClick={() => {
                                    setShowImageInfo(false);
                                }}>
                                <div className="Frame288">
                                    <div className="Pointing">
                                        <PoitingShapeSVG />
                                    </div>
                                    <div className="Frame199">
                                        <div
                                            className="ClickOverEachItemsYouWantToBotag"
                                            style={{ textAlign: "center" }}>
                                            <span className="Text400">Click over each items you want to </span>
                                            <span className="Text700">BO</span>
                                            <span className="Text400">tag.</span>
                                        </div>
                                        <div
                                            className="ThenLinkEachBotagToAnItemOnTheList"
                                            style={{ textAlign: "center" }}>
                                            <span className="Text400">Then link each </span>
                                            <span className="Text700">BO</span>
                                            <span className="Text400">tag to an item on the list.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {formFieldImageURL ? (
                            <ImageTags
                                src={formFieldImageURL}
                                alt="BOImage"
                                tags={BOTagsList}
                                onTagsChange={setBOTagsList}
                                reloadScale={reloadScale}
                                setReloadScale={setReloadScale}
                                showImageRemoveButton={true}
                                onImageRemove={handleOnImageRemove}
                            />
                        ) : (
                            <ImageUploading
                                disabled={{
                                    isDisabled: !formFieldRetailBrandID,
                                    message: "Please select the desired brand for this BOimage",
                                    onDisabledNotify: () => {
                                        setBrandNotSelectedShowError(true);
                                    }
                                }}
                                onImageUpload={handleOnImageUpload}
                                uploadToContainer={BLOB_BOIMAGE_CONTAINER}
                            />
                        )}
                    </div>

                    {/*<div className="MobilePreview">
                        <div className="Rectangle1"></div>
                        <div className="Frame313260">
                            <div className="Rectangle2"></div>
                        </div>
                        <div className="NavbarLogo">
                            {brandLogoURL && <img className="NavbarLogoImg" alt="Navbar logo" src={brandLogoURL} />}
                        </div>
                    </div>
                    */}

                    <BOImageMobilePreview
                        className="MobilePreview"
                        brandLogoURL={brandLogoURL}
                        imageURL={formFieldImageURL}
                    />
                </div>
            </div>
        </CardComponentContainer>
    );
};

const BOtagRightElements = () => {
    return (
        <div className="BOtagRightElementsContainer">
            <div className="Frame186">
                <div className="Rectangle7" style={{ background: "#FF9900" }} />
                <div className="BotagWithoutProduct">BOtag without product</div>
            </div>
            <div className="Frame1882">
                <div className="Rectangle7" style={{ background: "#00BB00" }} />
                <div className="BotagSelected">BOtag selected</div>
            </div>
            <div className="Frame187">
                <div className="Rectangle7" style={{ background: "#00AEEF" }} />
                <div className="BotagWithProduct">BOtag with product</div>
            </div>
        </div>
    );
};

/* #endregion */
